var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Login")]),(!_vm.$store.getters.isLoggedIn)?_c('LoginForm'):_c('div',[_c('p',[_vm._v("You are already logged in")]),_c('LogoutButton')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }